const CommonJobSvcBorder = () => {
  return (
    <div
      className="jobconfig-jobOption-content-border"
      style={{ paddingTop: 18 }}
    ></div>
  );
};

export default CommonJobSvcBorder;
